import { render } from "./Archives.vue?vue&type=template&id=2eb7e304&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"

import "./Archives.vue?vue&type=style&index=0&id=2eb7e304&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb7e304"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
